import { createApp } from 'vue';

import newsApp from './vue/news';

document.addEventListener('DOMContentLoaded', () => {
    const newsOverviewContainer = document.getElementById('news-overview');

    const newsWidgetContainers = document.querySelectorAll<HTMLElement>('.widget-news');

    if (newsOverviewContainer) {
        createApp(newsApp).mount(newsOverviewContainer);
    }

    newsWidgetContainers.forEach(container => {
        createApp(newsApp).mount(container);
    });
});
